import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSelector, useMakeSelector } from 'hooks/redux'
import { getIsEditing } from 'selectors/navigator'
import { makeGetConditionEvaluation } from 'selectors/feature/conditions'
import { setConditionField } from 'actions/feature/conditions'
import strings from 'utils/strings'
import Evaluation from '../base/Evaluation'

const SubQueryCarryEditor = (props) => {
  const dispatch = useDispatch()
  const isEditing = useSelector(getIsEditing)
  const { uri } = props
  const result = useMakeSelector(makeGetConditionEvaluation, {
    uri,
  })

  const handleSetEvaluation = (event) =>
    dispatch(setConditionField(uri, 'result', event.target.value))

  return (
    <>
      <Evaluation
        tooltip={strings.evaluation_condition}
        value={result}
        onChange={handleSetEvaluation}
        readonly={!isEditing}
      />
    </>
  )
}

SubQueryCarryEditor.propTypes = {
  uri: PropTypes.string,
}

export default SubQueryCarryEditor
